var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSmallRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.46096V3.77932C4.5 3.86897 4.54395 3.95334 4.61602 4.00607L11.4996 9.00002L4.61602 13.994C4.54395 14.0467 4.5 14.1311 4.5 14.2207V15.5391C4.5 15.6533 4.63008 15.7201 4.72324 15.6533L13.268 9.45529C13.5773 9.23029 13.5773 8.76975 13.268 8.54651L4.72324 2.34846C4.63008 2.2799 4.5 2.3467 4.5 2.46096Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmallRight);
export default __webpack_public_path__ + "static/media/arrowSmallRight.27fff91e645d7ced14378cb820905a98.svg";
export { ForwardRef as ReactComponent };